<template>
  <div class="h-100">
    <component v-if="customContent" :is="customContent" />
    <slot v-else />
  </div>
</template>

<script>
import ReviewHeaderContent from '@/components/ReviewHeaderContent';

export default {
  name: 'app-header-custom',
  components: {
    ReviewHeaderContent,
  },
  props: {
    customContent: String,
  },
};
</script>
